import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from 'react-redux';
import IntlMessages from 'util/IntlMessages';

import Widget from "components/prefabricated/Widget";
import {fetchUsers} from "../../../actions";
import CircularProgress from "@material-ui/core/CircularProgress";
import PeopleAltSharpIcon from '@material-ui/icons/PeopleAltSharp';
import { createSelector } from 'reselect';
// import Tooltip from "@material-ui/core/Tooltip";
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import InfoSharpIcon from '@material-ui/icons/InfoSharp';
import {
    BBDisableChildren,
    bbDoesCustomerHaveAccessToModule,
    bbErrorSection,
    isCurrentUserMemberOf
} from "../../../util/bbHelpers";
import KRIRibbon from "../../risk/KRIRibbon";
import Skeleton from "react-loading-skeleton";

const DataTile = (props) => {

    const { title = null,
        subTitle = null,
        color = "white",
        colorBgFunction = (dataStore) => color,
        colorTitle = () => {
            switch (colorBgFunction(dataStore)){
                case "primary" :
                    return "white"
                case "secondary" :
                    return "white"
                case "success" : //good
                    return "dark"
                case "info" : //no judgement, but awarness
                    return "dark"
                case "warning" : //marginal
                    return "white"
                case "danger" : //expected for bad
                    return "white"
                case "light" : //expected use is for while loading or "greyyed out"
                    return "muted"
                case "white" : //similar to info
                    return "dark"
                case "dark" :
                    return "white"
                case "light-gray" :
                    return "dark"
                case "lighter-gray" :
                    return "dark"
                case "lightest-gray" :
                    return "dark"
                case "bb-risk-lowest" :
                    return "white"
                case "bb-risk-low" :
                    return "dark"
                case "bb-risk-medium" :
                    return "dark"
                case "bb-risk-high" :
                    return "white"
                case "bb-risk-highest" :
                    return "white"
                case "inactive-gray" :
                    return "light"
                case "electric-blue" :
                    return "white"
                default:
                    return "dark"
            }
        },
        colorSubTitle = () => colorTitle(),
        tipText = null,
        tipLink = null,
        icon = null,
        iconFunction = (dataStore) => null,
        iconClasses="size-70",
        stateName = "users",
        stateElement = "users",
        useDeepDataStore = false,
        orientWide = false, //if true, will display in a wide view instead of a square
        deepDataStore = (dataStore) => dataStore, //used as the actual value of the store, so that subvalues can be picked
        stateLoaderName = "loadingUsers",
        stateLoaderError = "loadingUsersError",
        deepLoaderIndex = null,
        deepLoaderErrorIndex = null,
        stateFetchAction = fetchUsers(),
        dataIsLoadedConditionFunction = (dataStore) => null,
        preventDataFetchConditionFunction = (dataStore) => null,
        valueFunction = (stateData) => stateData.filter((x) => x.is_active).length,
        forceLoadingState = false,
        dontFetch = false,
        ribbonFunction = null, //a function that returns a ribbon object to display in top left
        showKRIRibbon = false,
        requiresModule = null,
        disableIfMissingModuleForAdminStaff = false,
        useMinimalistScalarLayout = false, //will force the layout to be minimalist with just a title, single number, and possibly a tooltip.
        id = null,

    } = props;

    const selectValueFromState = createSelector(
        state => state[stateName][stateElement],
        valueFunction
    )
    const value = useSelector(state =>
        selectValueFromState(state)
    )

    /**************************/
    /*Setup State and Dispatch*/
    /**************************/
    const dispatch = useDispatch();

    const {[stateElement]:dataStore, [stateLoaderName]:loading, [stateLoaderError]:loadingError} = useSelector((state) => state[stateName]);
    const {authUser} = useSelector(({auth}) => auth);
    const isAdminStaff = isCurrentUserMemberOf(authUser, "admin") || isCurrentUserMemberOf(authUser, "staff");
    const {customers:customersForModule, customerInView} = useSelector(({customer}) => customer);
    const customer = customersForModule ? customerInView ? customersForModule[customerInView] : null : null;
    // console.log(dataStore);
    // console.log("loadingUsers is ", loading, "loadingUsersError is ", loadingError);
    const [bgColor, setBgColor] = useState(colorBgFunction(dataStore));
    const [localLoading, setLocalLoading] = useState(deepLoaderIndex ? loading[`${deepLoaderIndex}`] : loading);
    const [localLoadingError, setLocalLoadingError] = useState(deepLoaderErrorIndex ? loadingError[`${deepLoaderErrorIndex}`] : loadingError);
    //console.log("deeploaderindex is", deepLoaderIndex, "loading is", loading, "loading[`${deepLoaderIndex}`] is ", loading[`${deepLoaderIndex}`]);

    const isDataTileDisabled = requiresModule ? (disableIfMissingModuleForAdminStaff && isAdminStaff) ? true : bbDoesCustomerHaveAccessToModule(customer, requiresModule) : true;

    useEffect(() => {
        if (!forceLoadingState) {
            // console.group("DataTile");
            // console.log("DataTile here is the store", deepDataStore, " and here is value: ", value);
            if (!dontFetch //only evaluate if this object is allowed to fetch
                && (
                    (useDeepDataStore && dataStore && (deepDataStore(dataStore) == null)) //for when the top level store is loaded but the deep one is not
                    || (useDeepDataStore && !dataStore) //for when the top level store is not loaded and the deep one is not
                    || (!useDeepDataStore && !dataStore) //for when deep store isn't being used and the top store needs a fetch
                    || dataIsLoadedConditionFunction(dataStore) //any other customer reason
                )
                && !preventDataFetchConditionFunction(dataStore)
            ) {
                // console.log("deepDataStore is empty, fetching for ", stateName, stateElement," Here is the store: ", deepDataStore(dataStore))
                if (stateFetchAction && authUser && !loading) {
                    // console.log("deepDataStore is empty, fetching. Here is the store: ", deepDataStore(dataStore), "authUser ", authUser)
                    dispatch(stateFetchAction);
                }
            }
            // console.groupEnd()
        }
        setBgColor(colorBgFunction(dataStore));
        setLocalLoading((deepLoaderIndex ? loading[`${deepLoaderIndex}`] : loading || !dataStore || !deepDataStore(dataStore)) && !dontFetch);
        setLocalLoadingError(deepLoaderErrorIndex ? loadingError[`${deepLoaderErrorIndex}`] : loadingError)

    }, [dataStore, dispatch, loading, loadingError, stateFetchAction, customersForModule, customerInView, authUser, colorBgFunction, dataIsLoadedConditionFunction,
                deepDataStore, deepLoaderErrorIndex, deepLoaderIndex, dontFetch, forceLoadingState, preventDataFetchConditionFunction, useDeepDataStore]);

    /**************************/
    /*END Setup State and Dispatch*/
    /**************************/

    const displayValue = () => {
        // console.log("Determining display value.  here is value: ", value);
        if (!isDataTileDisabled) {
            return "0x41"
        } else if (title) {
            return <div className={"animated fadeIn animation-duration-20"}> {title}</div>;
        } else if (deepLoaderIndex ? loading[`${deepLoaderIndex}`] : loading) {
            return "";
        } else if (useDeepDataStore && !deepDataStore(dataStore)) {
            // console.log("dataStore has been evaluated to undefined, returning blank.");
            return "...";
        } else if (value === null) {
            // console.log("value has been evaluated to null, returning blank.");
            return "";
        } else {
            return <div className={"animated fadeIn animation-duration-20"}> {value}</div>;
        }
    }

    const displayIcon = () => {
        if (iconFunction(dataStore)) {
            return iconFunction(dataStore);
        } else if (icon) {
            return icon;
        } else {
            return null ;
        }
    }

    const isTileAtLowestRiskRating = (!isDataTileDisabled && bgColor === "bb-risk-lowest");

  return (
      <div id={id ? id : null}>

          {((!dontFetch && deepDataStore(dataStore)) || (localLoading && !dontFetch) || dontFetch || forceLoadingState) &&

          <>
              {useMinimalistScalarLayout ?

                  <>

                      <div className={`p-2 m-2 animated fadeIn animation-duration-5 dataTile border-0 rounded `}>
                          <Tooltip disableFocusListener title={tipText} link={tipLink}>
                              <div>
                                  <div className="text-center">
                                      <h2 className={`font-weight-bold jr-fs-xxxl jr-font-weight-bold text-${localLoading || isTileAtLowestRiskRating ? "muted" : colorTitle()} mb-2 bb-font-fridge-bold`}>
                                          {(!localLoading && !localLoadingError && !forceLoadingState) &&
                                              displayValue()
                                          }
                                          {
                                              (forceLoadingState || localLoading) &&

                                              <CircularProgress size={"0.8em"} color={"inherit"} thickness={1.5}/>

                                          }
                                          {
                                              (localLoadingError) &&
                                              bbErrorSection("50px")
                                          }
                                      </h2>

                                  </div>
                                  <div className="text-center">
                                      <span className={`text-${localLoading || isTileAtLowestRiskRating ? "muted" :colorSubTitle()} fadeIn animation-duration-10 bb-font-fridge bb-font-fridge-medium-size`}>{!subTitle ? "" : subTitle}
                                          {/*{tipText &&*/}
                                          {/*    */}
                                          {/*        <InfoSharpIcon style={{fontSize: "14px", marginLeft: "auto", marginTop: -18, zIndex:5}} className={`text-muted`}/>*/}
                                          {/*    */}
                                          {/*}*/}
                                      </span>
                                  </div>
                              </div>
                          </Tooltip>
                          </div>

                  </>

                  : orientWide ?
              <>
                  <Widget styleName={`pl-3 pr-2 bg-${localLoading || isTileAtLowestRiskRating ? "light" : bgColor} animated fadeIn animation-duration-5 dataTile`}>
                      {ribbonFunction && ribbonFunction(dataStore)}
                      {/*{showKRIRibbon && <KRIRibbon/>}*/}
                      {tipText && <Tooltip disableFocusListener title={tipText} link={tipLink} className={"float-right"}>
                          <InfoSharpIcon style={{fontSize: "20px", marginLeft: "auto", marginTop: -20, zIndex:5}} className={`text-${localLoading || !isDataTileDisabled ? "muted" : colorTitle()} float-right`}/>
                      </Tooltip>}

                      {/*<BBDisableChildren*/}
                      {/*    isDisabled={isDataTileDisabled}*/}
                      {/*    moduleRequired = {requiresModule ? requiresModule : null}*/}
                      {/*    isCompact*/}
                      {/*    blurLevel={4}*/}
                      {/*>*/}

                              <div className="row">
                              {/*{icon &&*/}
                                  <div className="col-3">
                                      <span
                                          className={`${iconClasses} border-${localLoading || isTileAtLowestRiskRating ? "muted" : colorTitle()} text-${localLoading || isTileAtLowestRiskRating ? "muted" : colorTitle()} justify-content-center align-items-center rounded-circle`}
                                          style={{zIndex:4}}
                                      >
                                            {displayIcon()}
                                        </span>
                                  </div>
                              {/*// }*/}
                              <div className="col-9">
                                  {/*<div className="text-center">*/}
                                  {subTitle &&
                                      <h3 className={`text-${localLoading || isTileAtLowestRiskRating ? "muted" :colorSubTitle()} fadeIn animation-duration-10 bb-font-fridge bb-font-fridge-medium-size`}>{subTitle}</h3>
                                  }
                                      <h2 className={`jr-fs-xxxl jr-font-weight-bold text-${localLoading || isTileAtLowestRiskRating ? "muted" : colorTitle()} mb-2 bb-font-fridge-bold`}>
                                          {(!localLoading && !localLoadingError && !forceLoadingState) &&
                                            displayValue()
                                          }
                                          {
                                              (forceLoadingState || localLoading) &&

                                              <Skeleton />

                                          }
                                          {
                                              (localLoadingError) &&
                                              bbErrorSection()
                                          }
                                      </h2>

                                  {/*</div>*/}
                                  {/*<div className="text-center">*/}

                                  {/*</div>*/}

                              </div>
                          </div>

                      {/*</BBDisableChildren>*/}

                  </Widget>
              </>
              :
              <>
                  <Widget styleName={`px-2 bg-${localLoading || isTileAtLowestRiskRating ? "light" : bgColor} animated fadeIn animation-duration-5 dataTile`}>
                      {ribbonFunction && ribbonFunction(dataStore)}
                      {showKRIRibbon && <KRIRibbon/>}
                      {tipText && <Tooltip disableFocusListener title={tipText} link={tipLink} classname={"float-right"}>
                          <InfoSharpIcon style={{fontSize: "20px", marginLeft: "auto", marginTop: -20, zIndex:5}} className={`text-${localLoading || !isDataTileDisabled ? "muted" : colorTitle()} float-right`}/>
                      </Tooltip>}

                      <BBDisableChildren
                          isDisabled={isDataTileDisabled}
                          moduleRequired = {requiresModule ? requiresModule : null}
                          isCompact
                          blurLevel={4}
                      >
                          <div
                              className= {`d-flex flex-row justify-content-center ${icon ? " mt-1 mb-4" : " mt-0 mb-0"} `}
                          >


                              {icon &&
                                  <span
                                      className={`${iconClasses} border-${localLoading || isTileAtLowestRiskRating ? "muted" : colorTitle()} text-${localLoading || isTileAtLowestRiskRating ? "muted" : colorTitle()} d-flex flex-row justify-content-center align-items-center rounded-circle`}
                                      style={{zIndex: 4}}
                                  >
                                    {displayIcon()}
                                </span>
                              }

                          </div>
                          <div className="text-center">
                              <h2 className={`jr-fs-xxxl jr-font-weight-bold text-${localLoading || isTileAtLowestRiskRating ? "muted" : colorTitle()} mb-2 bb-font-fridge-bold`}>
                                  {(!localLoading && !localLoadingError && !forceLoadingState) &&
                                  displayValue()
                                  }
                                  {
                                      (forceLoadingState || localLoading) &&

                                      <CircularProgress size={"0.8em"} color={"inherit"} thickness={1.5}/>

                                  }
                                  {
                                      (localLoadingError) &&
                                      bbErrorSection("50px")
                                  }
                              </h2>

                          </div>
                      </BBDisableChildren>
                      {subTitle &&
                          <div className="text-center">
                              <span className={`text-${localLoading || isTileAtLowestRiskRating ? "muted" :colorSubTitle()} fadeIn animation-duration-10 bb-font-fridge bb-font-fridge-medium-size`}>{subTitle}</span>
                          </div>
                      }
                  </Widget>
              </>

              }


          </>

          }
      </div>
  );
};

export default DataTile;
